<div
  class="accordion-header toggle"
  [class.is-active]="isActive"
  (click)="toggle()"
>
  <ng-content />
  <svg-icon src="/assets/icons/general/chevron-right.svg" />
</div>
